<template>
	<div class="tpl about-us-wrap">
		<mt-header title="关于我们" fixed>
			<router-link :to="{name:'my-setting'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="main-content">
			<div class="logo">
				<img src="../../assets/img/common/logo.png" alt="">
				<p>鱼水缘</p>
				<p>当前版本：V 1.0</p>
			</div>
			<div class="options">
				<ul>
					<router-link tag="li" :to="{name:'feedback'}">
						<span>联系我们</span>
						<span><img src="../../assets/img/common/ic_arrow_enter@2x.png" alt=""></span>
					</router-link>
					<li @click="updateApp">
						<span>版本更新</span>
						<span><img src="../../assets/img/common/ic_arrow_enter@2x.png" alt=""></span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "about-us",
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
		},
		methods: {
			updateApp() {

			}
		}
	}
</script>

<style scoped>
	.about-us-wrap {
		padding-top: 5rem;
		background: #fff;
		min-height: 100vh;
	}
	
	h2 {
		font-size: 1.5rem;
		color: #282828;
		text-align: center;
	}
	
	.logo {
		text-align: center;
		padding: 3rem 0;
		font-size: 0.8rem;
		color: #7b7b7b;
		line-height: 1.8rem;
	}
	
	.logo img {
		width: 5rem;
	}
	
	.options {
		margin-top: 4rem;
	}
	
	.options li {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 1rem;
		border-top: 1px solid #f3f3f3;
		font-size: 0.9rem;
		color: #282828;
		opacity: 0.8;
	}
	
	.options li:active {
		background: #fafafa;
	}
	
	.options li:last-of-type {
		border-bottom: 1px solid #f3f3f3;
	}
	
	.options li img {
		width: 1.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/AboutUs.vue